import React, {Fragment} from "react";
import ComponentRule from "../../slate/booq/ComponentRule";
import Select from "../../../Select";
import ComponentConfig from "../../../ComponentConfig";
import {optionsTemplate} from "../../../../../utils/formatters";
import TextInput from "../../../TextInput";
import CheckBox from "../../../CheckBox";
import Button from "../../../Button";
import {Editor, Element, Range, Text, Transforms} from "slate";
import {set} from "../../../../../utils/dotutils";
import Portal from "../../../../layout/Portal";
import Modal from "../../../../layout/Modal";
import {isEmpty} from "../../../../../utils/other";
import {Rules as ARules} from "../html/a";

const LinkNode = (props) => {
    return <a href="" {...props.attributes}>{props.children}</a>;
}

export const LinkModal = (props) => {
    const {type, value, target} = props.data;
    return <div className="row">
        <div className="col-md-12">
            <div className="row form-row">
                <div className="col-md-12">
                    <Select name="type" objectValue={false} optionname="linktype" storeType="local" saveChanges={props.setValue} value={type} label="Link típusa" />
                </div>
            </div>
            {!!type && <div className="row form-row">
                <div className="col-md-12">
                    {type && type !== "url"
                        ?
                        <ComponentConfig componentName={type}>
                            {(configProps) => {
                                const urlField = Object.keys(configProps.componentConfig.fielddefs || {}).find((field) => {
                                    return configProps.componentConfig.fielddefs[field].object === "url"
                                });
                                let valueKey = configProps.componentConfig.idfield;
                                if (urlField) {
                                    valueKey = configProps.componentConfig.fielddefs[urlField].boundfield || valueKey;
                                }
                                return <Select
                                    name="value"
                                    objectValue={false}
                                    component={type}
                                    valueKey={valueKey}
                                    groupBy={{
                                        by: [valueKey]
                                    }}
                                    optionsTemplate={optionsTemplate(type)}
                                    saveChanges={props.setValue}
                                    storeType="remote"
                                    value={value}
                                    label="Link tárgya"
                                />
                            }
                            }
                        </ComponentConfig>
                        :
                        <TextInput name="value" value={value || ''} saveChanges={(field, value) => props.setValue(field, value.trim())} label="Url" />
                    }
                </div>
            </div>}
            {props.targetAble !== false && <div className="row form-row">
                <div className="col-md-12">
                    <CheckBox name="target" saveChanges={(field, value) => props.setValue(field, value ? '_blank' : null)} value={!!target} checked={!!target} label="Megnyitás új ablakban" />
                </div>
            </div>}
        </div>
    </div>;
};

const UnlinkButton = (props) => {
    return <Button
        onClick={(e) => {
            e && e.preventDefault();
            Transforms.unwrapNodes(props.editor, {
                match: n =>
                    !Editor.isEditor(n) && Element.isElement(n) && n.type === 'component' && n.props.type === 'link',
            })
            return false;
        }}
        icon="unlink"
        color="default"
        tooltip="Link törlése"
        disabled={props.disabled || !props.isActive}
    />
};

const defaultEditData = {
    target: ''
}

class LinkButton extends React.Component<any, any> {

    state = {
        editing: false,
        selection: null
    }

    openEditor = (e) => {
        e && e.preventDefault();
        let propsValue = null;
        if (this.props.isActive) {
            const [match] = Editor.nodes(this.props.editor, {
                match: n => n.type === 'component' && n.props.type === 'link'
            });
            propsValue = {...(match?.[0].props || {...defaultEditData})};
        } else {
            propsValue = {...defaultEditData};
        }
        let values = {...(propsValue.presetdata || {})};
        if (propsValue.filter) {
            let type = null;
            let value = null;
            propsValue.filter.map((filter) => {
                if (filter.field === "component") {
                    type = filter.value;
                }
                if (filter.field === "component_id") {
                    value = filter.value;
                }
            });
            values.type = type;
            values.value = value;
        } else {
            values.type = "url";
            values.value = values.url;
        }
        this.setState({editing: true, value: values, selection: this.props.editor.selection});
        return false;
    }

    onModalChange = (field, value) => {
        const newValue = {...this.state.value};
        set(newValue, field, value);
        if(field + "" === 'type' && value + "" !== "" + this.state.value.type) {
            newValue.value = null;
        }
        this.setState({value: newValue});
    }

    render() {
        const values = this.state.value || {};
        return <Fragment>
            <Button
                onClick={this.openEditor}
                icon="link"
                color={this.props.isActive ? "primary" : "default"}
                tooltip={"Link" + (!this.props.isActive ? " beszúrása" : " szerkesztése")}
                disabled={this.props.disabled || !this.props.isActive && (!this.props.selection || !Range.isExpanded(this.props.selection))}
            />
            <Portal>
                <Modal
                    state={this.state.editing ? "on" : "off"}
                    header={"Link" + (!this.props.isActive ? " beszúrása" : " szerkesztése")}
                    buttons={[
                        {
                            text: "Ok",
                            props: {color: "primary", disabled: isEmpty(values.value)},
                            onClick: async () => {
                                const value = {...this.state.value};
                                const data = {presetdata: {target: value.target}};
                                if (value.type === "url") {
                                    data.presetdata.url = value.value;
                                } else {
                                    data.filter = [{field: "component", value: value.type},{field: "component_id", value: value.value}];
                                }
                                //const { selection } = editor
                                //const isCollapsed = selection && Range.isCollapsed(selection)
                                const props = {
                                    type: 'link',
                                    ...data
                                };
                                const dive = (fragment) => {
                                    if (fragment?.children) {
                                        return dive(fragment.children?.[0]);
                                    } else {
                                        return fragment?.text;
                                    }
                                }
                                const link = {
                                    type: 'component',
                                    props,
                                    children: [{text: dive(this.props.editor.getFragment()?.[0])}]
                                };
                                //console.log(link);

                                //console.log(this.props.editor.getFragment());
                                //console.log(ReactEditor.findPath(this.props.editor, this.props.editor.getFragment()));

                                //console.log(this.state.selection);

                                //console.log(this.props.editor);
                                //console.log(this.state.selection);
                                //console.log(link);
                                Transforms.setSelection(this.props.editor, this.state.selection);
                                if (!this.props.isActive) {
                                    Transforms.insertNodes(
                                        this.props.editor,
                                        link,
                                        {
                                            match: n => Text.isText(n),
                                        }
                                    )
                                } else {
                                    Transforms.setNodes(this.props.editor, {
                                        ...link
                                    }, {
                                        match: n => n.type === 'component' && n.props.type === 'link'
                                    });
                                }
                                /*Transforms.wrapNodes(
                                    this.props.editor,
                                    link,
                                    { match: n => Text.isText(n) }
                                )
                                Transforms.collapse(this.props.editor, { edge: 'end' })*/
                                this.setState({editing:false});
                            }
                        }, {
                            text: "Mégse",
                            props: {color: "default"},
                            onClose: true,
                            onClick: async () => {
                                this.setState({editing:false});
                            }
                        }
                    ]}>
                    <LinkModal data={values} setValue={this.onModalChange} />
                </Modal>
            </Portal>
        </Fragment>
    }
}

export default LinkNode;

let LinkRule = ComponentRule({
    type: 'link',
    render: LinkNode,
    tagType: () => 'inline',
    isVoid: () => false,
    toolbarButton: (props) => {
        return <Fragment>
            <LinkButton {...props} />
            <UnlinkButton {...props} />
        </Fragment>
    }
});

let originalLinkRuleDeserialize = LinkRule.deserialize;

LinkRule.deserialize = (el, next) => {
    let d = ARules.a.deserialize(el, next);
    if (d !== undefined) {
        return {
            type: "component",
            props: {
                type: "link",
                presetdata: {
                    target: d.attr?.target === "_blank",
                    url: d.attr?.href || "",
                }
            },
            children: next(el.childNodes)
        }
    }
    return originalLinkRuleDeserialize(el, next);
}

export const Rules = {
    "link": LinkRule
}